export default __webpack_public_path__ + "static/media/k4.6edda24f.svg";